module.exports = __webpack_public_path__ + "static/media/dashboard.11ec27d5.svg";